import biliMirror, { techReportPb, canBatchTechReport } from '@bilibili/bili-mirror'
import { nanoid } from 'nanoid'
import { isString, isObject, deepCopy } from '@Utils/index'
import {
  HOME_MARK,
  MY_REPORT,
  COOPERATION_MODE,
  TOP_NAVIGATION,
  CREATE_TASK_FIRST,
  TOP_MARK,
  ORDER_MARK,
  ORDER_DETAIL_MARK,
  TASK_DETAIL_MARK,
  UPPER_MARK,
  LIVE_UPPER_MARK
} from '@Constant/behaviorTrack'

import { SPM_ID } from '@Constant/behaviorTrack'
import { setSessionStorage } from './system'

export const reportConfig = {
  globalRequestId: null
}

export function updateRequestId() {
  reportConfig.globalRequestId = nanoid()
}

export const ClickPvRelation = {
  // 在选择合作类型页面点击下一步，跳转到创建任务页面
  [COOPERATION_MODE.NEXT]: CREATE_TASK_FIRST.PV,
  // 导航栏点击发布任务，跳转到合作类型选择页面
  [TOP_NAVIGATION.Task]: COOPERATION_MODE.PV,
  // 购物车里点击发布任务, 跳转到创建任务页面
  [TOP_MARK.TOP_SELECTED_LAUNCH]: CREATE_TASK_FIRST.PV,
  // 订单详情
  [ORDER_MARK.MY_ORDER_CLICK]: ORDER_DETAIL_MARK.PV,
  // 任务详情
  [TASK_DETAIL_MARK.TASK_DETAIL_CLICK]: TASK_DETAIL_MARK.PV,
  // up住广场
  [TOP_NAVIGATION.upperList]: UPPER_MARK.PV,
  [TOP_NAVIGATION.UpperContent]: UPPER_MARK.PV,
  [TOP_NAVIGATION.UpperLive]: LIVE_UPPER_MARK.PV,
  [TOP_NAVIGATION.CaseReport]: MY_REPORT.PV,
  [TOP_NAVIGATION.mine]: ORDER_MARK.PV,
  // 首页点击订单统计跳转订单列表
  [HOME_MARK.HOME_PANELMORE_CLICK]: ORDER_MARK.PV,
  [HOME_MARK.HOME_PANELACCEPT_CLICK]: ORDER_MARK.PV,
  [HOME_MARK.HOME_PANELPAY_CLICK]: ORDER_MARK.PV,
  [HOME_MARK.HOME_PANELONGOING_CLICK]: ORDER_MARK.PV,
  [HOME_MARK.HOME_CLOSE_CLICK]: ORDER_MARK.PV,
  [HOME_MARK.HOME_UNUSUAL_CLICK]: ORDER_MARK.PV,
  [HOME_MARK.HOME_PANELMORE_CLICK]: ORDER_MARK.PV
}

export const parserClickTrackData = source => {
  try {
    const clickTrackPvData = sessionStorage.getItem('pv-click-from')

    console.log('click-from:', clickTrackPvData, ClickPvRelation[clickTrackPvData])

    // 如果是匹配pv页面清除
    if (source === ClickPvRelation[clickTrackPvData]) {
      console.log('click-from: match')
      clickTrackPvData && sessionStorage.removeItem('pv-click-from')

      return clickTrackPvData
    }

    return ''
  } catch (e) {
    console.log(e)
    return ''
  }
}

class SPMReport {
  accountInfo = {}
  setAccountInfo(info) {
    this.accountInfo = info
  }

  setSpmId(spmId = '') {
    if (window.reportObserver) {
      window.reportObserver.setSPM_id(spmId || SPM_ID)
    }
  }

  reportElementSpmData(key, data = {}, behavior = {}) {
    this.setSpmId(SPM_ID)
    if (window.reportObserver && key) {
      const extra = {}
      if (behavior.rid) {
        extra.request_id = reportConfig.globalRequestId
      }

      // 链路追踪
      if (ClickPvRelation[key]) {
        setSessionStorage('pv-click-from', key)
      }

      window.spmReportData[key] = this.mergeSpmData({ ...data, ...extra })
      window.reportObserver.forceCommit()
    }
  }

  reportPagePv(referUrl = window.document.referrer, msg = '', targetUrl = window.location.href) {
    this.setSpmId(SPM_ID)

    if (window.reportObserver) {
      window.reportObserver.sendPV(encodeURIComponent(this.getCompleteUrl(referUrl)), JSON.stringify(this.mergeSpmData(deepCopy(msg))), this.getCompleteUrl(targetUrl))
    }
  }

  mergeSpmData(data = null) {
    const accountInfo = this.accountInfo || {}
    const datas = {
      mid: accountInfo.mid,
      account_id: accountInfo.account_id,
      account_role: accountInfo.account_role,
      department_type: accountInfo.department_type
    }
    if (isObject(data)) {
      return {
        ...datas,
        ...deepCopy(data)
      }
    }
    if (isString(data)) {
      datas.source = data
    }
    return datas
  }

  getCompleteUrl(url) {
    if (/^http(s)?:/.test(url)) {
      return url
    }
    if (/^\/.+/.test(window.location.pathname)) {
      return `${window.location.origin}${window.location.pathname}#${url}`
    }
    return `${window.location.origin}/#${url}`
  }

  reportApiError(params = {}) {
    try {
      if (process.env.NODE_ENV === 'development') {
        return
      }
      canBatchTechReport(
        {
          type: 'error',
          msg: {
            ...params
          }
        },
        {
          isBatch: false
        }
      )
    } catch (e) {
      console.error(e)
    }
  }

  reportApiNormal(params) {
    try {
      if (process.env.NODE_ENV === 'development') {
        return
      }
      canBatchTechReport(
        {
          type: 'custom',
          msg: {
            ...params
          }
        },
        {
          isBatch: true
        }
      )
    } catch (e) {
      console.error(e)
    }
  }
}

export const spmReport = new SPMReport()

window.sendSwReport = function (params) {
  try {
    const config = {
      originUrl: params.data.originUrl,
      count: params.data.index,
      type: params.data.type
    }

    const url = new URL(params.data.url)

    if (url) {
      config.host = url.host
    }

    if (params.data.type === 'full-fail') {
      delete config.count
    }

    spmReport.reportElementSpmData('sw_request_log_report', config)
  } catch (e) {
    console.error(e)
  }
}
